module.exports = __webpack_public_path__ + "img/elections.327688a1.svg";